// extracted by mini-css-extract-plugin
module.exports = {"start-trial-break":"css_start-trial-break__2xfnz","dark-break":"css_dark-break__1X1og"};